import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";

const FAQAgentSection = () => {
  return <FAQSectionI18n translationPrefix="aiAgent" bgClass="bg-secondary/30" />;
};

export default FAQAgentSection;
